import {Card as MuiCard, CardContent as MuiCardContent} from '@mui/material';
import Grid from '@mui/material/Grid';
import React, {useState} from 'react';
import styled from 'styled-components';
import {
  awsS3,
  dropbox,
  gDrive,
  iconNotifyAlertTriangle,
  iconSuccessGreen,
  successStatusIcon
} from "../../assets/icons/icons";
import {useAppSelector} from "../../store/hooks";
import {connectedExtStorage} from "../../store/selectors";
import ExternalStorage from "../UserPages/UserSettings/ExternalStorage/ExternalStorage";
import Modal from "../../components/Dialogs/Modal/Modal";
import {Chip} from "../../components/StyledComponents";
import {LockCircle} from "iconsax-reactjs";

const Card = styled(MuiCard)`
  position: relative;
  padding: 24px;
  color: #111827;
  border: 0;
  border-bottom: 4px solid #EAECF0;
  border-radius: 16px;
  text-transform: capitalize;
`;

const CardContent = styled(MuiCardContent)`
  position: relative;
  padding: 0 !important;
`;

type InfoProps = {
  lastBackup: string;
  total: number;
  appsCount: number;
};

const storageList = {
  "dropbox": {title: 'Dropbox', icon: dropbox},
  "google_drive": {title: 'Google Drive', icon: gDrive},
  "s3": {title: 'AWS S3', icon: awsS3}
}

const DashInfoCard: React.FC<InfoProps> = ({lastBackup, total, appsCount}) => {
  const external = useAppSelector(connectedExtStorage)?.[0];
  const [open, setOpen] = useState<boolean>(false);


  return (
    <Grid container spacing={4} className='dashboard-info-cards'>
      <Grid size={{xs: 12, sm: 6, md: 6, lg: 3, xl: 3}}>
        <Card className='green-card'>
          <CardContent>
            <div className='info-cards-title'>Overall Protection</div>
            <div className='info-cards-block'>
              <div className='info-cards-ico'>
                <img src={iconSuccessGreen} loading="lazy"/>
              </div>
              <div className='info-cards-data'>Infrastructure status: OK</div>
            </div>
            <div className='info-cards-subtitle'>AWS: OK, BackupLabs: OK</div>
          </CardContent>
        </Card>
      </Grid>
      <Grid size={{xs: 12, sm: 6, md: 6, lg: 3, xl: 3}}>
        <Card className='blue-card'>
          <CardContent>
            <div className='info-cards-title'>Last Successful Backup</div>
            <div className='info-cards-block'>
              <div className='info-cards-ico'>
                <img src={successStatusIcon}/>
              </div>
              <div className='info-cards-data'>{lastBackup ? lastBackup : '-'}</div>
            </div>
            <div className='info-cards-subtitle'>All apps backed up</div>
          </CardContent>
        </Card>
      </Grid>
      <Grid size={{xs: 12, sm: 6, md: 6, lg: 3, xl: 3}}>
        <Card className='violet-card'>
          <CardContent>
            <div className='info-cards-title'>Protected objects</div>
            <div className='info-cards-block'>
              <div className='info-cards-ico'>
                <LockCircle size={24} variant="Bold" color='#B13BF6'/>
              </div>
              <div className='info-cards-data'>Total: {total ? total : '-'} {total === 1 ? 'item' : 'items'}</div>
            </div>
            <div className='info-cards-subtitle'>Connected apps: {appsCount}</div>

          </CardContent>
        </Card>
      </Grid>
      <Grid size={{xs: 12, sm: 6, md: 6, lg: 3, xl: 3}}>
        <Card className='yellow-card' onClick={() => {
          setOpen(true)
        }}>
          <CardContent>
            <div className='info-cards-title'>External Storage</div>


            <div className='info-cards-block'>
              <div className='info-cards-ico'>
                {external ?
                  <img src={storageList[external]?.icon} loading="lazy"/> :
                  <img src={iconNotifyAlertTriangle} className='info-cards-ico-no-storage' loading="lazy"/>
                }
              </div>
              <div className='info-cards-data'>
                {external ? storageList[external]?.title : 'Not connected'}
              </div>
            </div>
            <Chip
              label={external ? 'Synced' : 'Disconnected'}
              className={external ? 'success' : 'error'}
            />
          </CardContent>
        </Card>
      </Grid>
      <Modal
        isOpen={open}
        className='ext-storage-modal'
        closeNotification={() => setOpen(false)}
        child={<ExternalStorage
          platformModal='trello'
          closeModal={() => setOpen(false)}
        />}
      />
    </Grid>
  );
};

export default DashInfoCard;
